export default "__VITE_ASSET__D9kn$1E8__"